/** Must match src/shared/supportTicketSubjects.ts on the backend */
export const WHITEPAPER_DOWNLOAD_SUBJECT = 'White Paper Download Request'

export const CONTACT_US_SUBJECT_PREFIX = 'Contact Us'

export const CONTACT_INQUIRY_TYPES = [
  'Sales',
  'Support',
  'Partnerships',
  'Press & Media',
  'Investor Relations',
  'General Inquiry',
]

export function formatWhitepaperRequestMessage(company) {
  return `Company: ${company.trim()}\n\nRequested access to the Security & AI Privacy Whitepaper.`
}

export function formatContactUsMessage(company, inquiryType, message) {
  const trimmedMessage = message?.trim()
  const lines = [`Company: ${company.trim()}`, `Inquiry Type: ${inquiryType}`, '']
  if (trimmedMessage) {
    lines.push(trimmedMessage)
  } else {
    lines.push('(No additional message provided)')
  }
  return lines.join('\n')
}

export function contactUsSubject(inquiryType) {
  return `${CONTACT_US_SUBJECT_PREFIX}: ${inquiryType}`
}
